import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-950">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-800 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-100">页面找不到了</h1>
        <p className="mt-2 text-base text-foreground-600 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">您访问的页面可能已删除或不存在</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-950 font-medium whitespace-nowrap hover:bg-primary-400 transition-colors"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}